<template>
	<ValidationObserver ref="observer" v-slot="{ handleSubmit }">
		<form @submit.prevent="handleSubmit(saveDealer)">
			<header class="modal-card-head">
				<h4 class="modal-card-title">
					<span>{{ modalTitle(name) }} <strong>Dealer</strong></span>
					<span v-if="dealer.id">#{{ dealer.id }}</span>
				</h4>
			</header>
			<div class="modal-card-body">
				<b-loading :is-full-page="false" v-model="isOpening"></b-loading>
				<div class="modal-card mb-3">
					<InputWithValidation class="mb-5" rules="required|min:3" type="text" label="Nome" size="is-medium" v-model="dealer.name" />
					<div class="columns">
						<div class="column">
							<InputWithValidation rules="required|min:14" v-mask="'(##) ####-####'" type="text" label="Telefone" size="is-medium" v-model="dealer.phone" />
						</div>
						<div class="column">
							<InputWithValidation rules="required|min:18" v-mask="'##.###.###/####-##'" type="text" label="CNPJ" size="is-medium" v-model="dealer.document" />
						</div>
					</div>
					<h3 class="is-size-5 is-medium has-text-primary">Localização</h3>
					<hr class="my-2 divider">
					<div class="columns">
						<div class="column">
							<b-field label="CEP">
								<b-input type="text" v-mask="'#####-###'" icon-right="map-marker" size="is-medium" @blur="completeAdress(dealer.code)" v-model="dealer.code" />
							</b-field>
						</div>
						<div class="column">
							<InputWithValidation rules="required|min:3" type="text" label="Bairro" size="is-medium" v-model="dealer.neighborhood" />
						</div>
					</div>
					<InputWithValidation class="mb-5" rules="required" type="text" label="Endereço" size="is-medium" v-model="dealer.address" />
					<div class="columns mb-5">
						<div class="column">
							<InputWithValidation rules="required" type="text" label="Cidade" size="is-medium" v-model="dealer.city" />
						</div>
						<div class="column">
							<SelectWithValidation rules="required" label="Estado" size="is-medium" v-model="dealer.state">
								<option value="AC">Acre</option>
								<option value="AL">Alagoas</option>
								<option value="AP">Amapá</option>
								<option value="AM">Amazonas</option>
								<option value="BA">Bahia</option>
								<option value="CE">Ceará</option>
								<option value="DF">Distrito Federal</option>
								<option value="ES">Espírito Santo</option>
								<option value="GO">Goiás</option>
								<option value="MA">Maranhão</option>
								<option value="MT">Mato Grosso</option>
								<option value="MS">Mato Grosso do Sul</option>
								<option value="MG">Minas Gerais</option>
								<option value="PA">Pará</option>
								<option value="PB">Paraíba</option>
								<option value="PR">Paraná</option>
								<option value="PE">Pernambuco</option>
								<option value="PI">Piauí</option>
								<option value="RJ">Rio de Janeiro</option>
								<option value="RN">Rio Grande do Norte</option>
								<option value="RS">Rio Grande do Sul</option>
								<option value="RO">Rondônia</option>
								<option value="RR">Roraima</option>
								<option value="SC">Santa Catarina</option>
								<option value="SP">São Paulo</option>
								<option value="SE">Sergipe</option>
								<option value="TO">Tocantins</option>
								<option value="EX">Estrangeiro</option>
							</SelectWithValidation>
						</div>
					</div>

					<div v-if="dealers.length > 0">
						<b-field label="Dealers Agrupados" class="mb-4">
							<multiselect v-model="dealer.group" name="delaers" :options="dealers" label="name" track-by="name" placeholder="" multiple preserve-search :close-on-select="false" :clear-on-select="false" selectLabel="Selecionar" selectedLabel="Selecionado" deselectLabel="Remover">
								<span slot="noResult">Nenhum dealer encontrado</span>
							</multiselect>
						</b-field>
					</div>

					<small class="modal-updated" v-if="dealer.updated_at">Última Modificação: {{ format(dealer.updated_at) }}</small>
				</div>
			</div>
			<footer class="modal-card-foot">
				<b-button class="is-rounded is-outlined is-danger" @click="$emit('close')">Fechar</b-button>
				<b-button native-type="submit" class="is-rounded is-primary" :loading="loading">Salvar</b-button>
			</footer>
		</form>
	</ValidationObserver>
</template>

<script>
import axios from 'axios'
import InputWithValidation from '@/components/inputs/InputWithValidation'
import SelectWithValidation from '@/components/inputs/SelectWithValidation'
import { ValidationObserver } from 'vee-validate'
import Api from '@/services/api'
import eventHub from '@/services/eventHub'
import { successToast, errorToast } from '@/mixins/toast'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/mixins/generic'

export default {
	components: {
		InputWithValidation,
		SelectWithValidation,
		ValidationObserver,
		Multiselect
	},
	props: {
		id: {
			type: [Number, String],
			required: false
		},
		name: {
			type: String,
			required: true
		},
		root: {
			type: String,
			required: false
		}
	},
	data() {
		return {
			isOpening: false,
			loading: false,
			dealer: {
				type: 1,
				name: '',
				phone: '',
				document: '',
				code: '',
				address: '',
				city: '',
				state: '',
				neighborhood: ''
			},
			dealers: []
		}
	},
	methods: {
		completeAdress(cep) {
			let d = this.dealer
			axios
				.get(`https://viacep.com.br/ws/${cep}/json/`)
				.then(response => {
					let a = response.data
					d.address = a.logradouro
					d.city = a.localidade
					d.state = a.uf
					d.neighborhood = a.bairro
					// console.log(d, a)
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		async saveDealer() {
			this.name === 'New' ? await this.store() : await this.update()
		},
		async store() {
			try {
				this.loading = true
				const response = await Api.post(`dealer/store`, this.dealer)
				const { status } = response
				if (status === 201) {
					// const { message } = response.data
					this.$emit('close')
					history.pushState({}, '', '/dealers')
					successToast('O dealer foi <strong>cadastrado</strong> com sucesso!')
					eventHub.$emit('reload-dealers')
				}
			} catch (e) {
				const { status } = e
				if (status === 422) {
					// const { message } = e.data
					errorToast('Ocorreu um <strong>erro</strong> ao criar o dealer!')
				}
			} finally {
				this.loading = false
			}
		},
		async update() {
			try {
				this.loading = true
				const response = await Api.put(`dealer/update/${this.id}`, this.dealer)
				const { status } = response
				if (status === 200) {
					// const { message } = response.data
					this.$emit('close')
					history.pushState({}, '', '/dealers')
					successToast('O dealer foi <strong>atualizado</strong> com sucesso!')
					eventHub.$emit('reload-dealers')
				}
			} catch (e) {
				const { status } = e
				if (status === 422) {
					// const { message } = e.data
					errorToast('Ocorreu um <strong>erro</strong> ao atualizar o dealer!')
				}
			} finally {
				this.loading = false
			}
		},
		async findById() {
			if (this.name === 'Edit') {
				this.isOpening = true
				try {
					const response = await Api.get(`dealer/findById/${this.id}`)
					const { status } = response
					if (status === 200) {
						const { data } = response
						this.dealer = data
						this.isOpening = false
					}
				} catch (e) {
					console.log(e)
				}
			}
		},
		async getAllDealers() {
			try {
				const response = await Api.get('dealer/findAll')

				if (response.status === 200) {
					this.dealers = response.data.filter((d) => {
						if (d.group_id && d.group_id != this.dealer.group_id) {
							d.$isDisabled = true
						}

						return d.id != this.dealer.id
					})
				}
			} catch (e) {
				console.log(e)
			}
		}
	},
	mounted() {
		this.findById()
		this.getAllDealers()
	}
}
</script>
